﻿<template>
    <aunoa-card v-bind="cardAttrs" :required="required">
        <aunoa-card-header :icon="icon" :text="title(t)" />
        <div class="list-group list-group-flush">
            <div class="list-group-item text-center text-muted small" v-if="links.length===0" v-text="t('Mate.NoEntryYet')" />
            <router-link
                v-for="({name,icon,parentNames,path,permitted},i) in links"
                class="list-group-item list-group-item-action d-flex justify-content-start align-items-start link-item"
                :class="{'disabled':!permitted}"
                :to="path">
                <i class="fa-2x text-primary" :class="icon"  />
                <span>
                    <i class="fas float-end text-primary" :class="[`fa-circle-${i+1}`]" />
                    <span v-text="ensureTextTranslated(name)" />
                    <br>
                    <span class="as-breadcrumb">
                        <span class="small text-muted" v-for="n in parentNames" v-text="ensureTextTranslated(n)" />                        
                    </span>
                </span>
            </router-link>
        </div>
    </aunoa-card>
</template>

<script lang="ts">

import {useAunoaI18n, useMostRecentlyUsedPages, AunoaCard, AunoaCardHeader} from "bootstrap-aunoa";
import {useDashboardCard} from "../useDashboard";
import {useAuth} from "../../../utils/useAuth";
import {computed, defineComponent} from "vue";
import {useTenancy} from "@tnt/mate-api";

const meta = {
    createdAt: "2021-04-22T00:00:00.000Z",
    icon: "fad fa-history",
    title: (t:any) => t("Mate.MostRecentlyUsed"),
    required: true
}

export default defineComponent({
    $$meta: meta,
    name: "RecentlyUsedCard",
    components: {AunoaCard, AunoaCardHeader},
    setup() {

        const card = useDashboardCard();
        const {navigation, user} = useAuth()
        const {primaryTenantOid} = useTenancy();
        const {t, ensureTextTranslated} = useAunoaI18n();
        const {getPathes} = useMostRecentlyUsedPages(<any>user.value);
        const pathDict = computed(() => navigation.value.pathDict || {});
        const links = computed(() => getPathes()
            .map(path => pathDict.value[path])
            .filter(Boolean)
            .map(link => ({
                ...link,
                permitted: navigation.value.permissions[link.path]?.[primaryTenantOid.value]
            }))
        );

        return {
            t,
            links,
            ensureTextTranslated,
            ...meta,
            ...card
        }
    }
});

</script>

